export function LegalContentQuery(url: string) {
  return /* GraphQL */ `
  query pageQuery {
    pageCollection(where: { url: "${url}" }, limit: 1) {
      items {
        legal {
          legalHeading
          legalComparisonBlock
          accordiansCollection(limit: 1) {
            items {
              title
              bodyCollection(limit: 10) {
                items {
                  markdown: body
                }
              }
            }
          }
        }
      }
    }
  }
  `;
}
